module.exports = __webpack_public_path__ + "img/koh_absorption.ac6856aa.png";